export enum StripePaymentMode {
  Token = 'token',
  PaymentMethod = 'paymentMethod'
}
